import React, { useState } from "react";
import CustomButton from "../../../components/common/CustomButton/CustomButton";
import CustomSwitch from "../../../components/common/CustomSwitch";

const DropdownsTab = () => {
  const [dropdowns, setDropdowns] = useState({
    rejectionType: [
      { id: 1, name: "Bank Account No.", isActive: false },
      { id: 2, name: "Adhar card", isActive: true },
    ],
    qualifications: [
      { id: 1, name: "Experience Level", isActive: true },
      { id: 2, name: "Certification", isActive: false },
    ],
  });

  const [expandedSection, setExpandedSection] = useState(null);
  const [newDropdownName, setNewDropdownName] = useState("");

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
    setNewDropdownName("");
  };

  const handleAddDropdown = (section) => {
    if (!newDropdownName.trim()) return;

    const newItem = {
      id: dropdowns[section].length + 1,
      name: newDropdownName,
      isActive: false,
    };

    setDropdowns((prev) => ({
      ...prev,
      [section]: [...prev[section], newItem],
    }));

    setNewDropdownName("");
  };

  const handleToggleStatus = (section, id) => {
    setDropdowns((prev) => ({
      ...prev,
      [section]: prev[section].map((item) =>
        item.id === id ? { ...item, isActive: !item.isActive } : item
      ),
    }));
  };

  const handleDeleteDropdown = (section, id) => {
    setDropdowns((prev) => ({
      ...prev,
      [section]: prev[section].filter((item) => item.id !== id),
    }));
  };

  const renderSection = (section, title, description) => {
    const isExpanded = expandedSection === section;
    const items = dropdowns[section];

    return (
      <div className="border border-gray-200 rounded-lg p-4 mb-4">
        <div className="flex justify-between items-center">
          <div>
            <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
            <p className="text-sm text-gray-600">{description}</p>
          </div>
          <button
            onClick={() => toggleSection(section)}
            className="flex items-center text-blue-600 hover:underline"
          >
            Drop Down List
            <svg
              className={`ml-2 w-4 h-4 transform ${isExpanded ? "rotate-180" : ""}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>

        {isExpanded && (
          <div className="mt-4">
            <div className="flex items-center mb-4">
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Drop Down Description/Text
                </label>
                <input
                  type="text"
                  value={newDropdownName}
                  onChange={(e) => setNewDropdownName(e.target.value)}
                  placeholder="Enter"
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <CustomButton
                onClick={() => handleAddDropdown(section)}
                label="Add"
                variant="contained"
                className="ml-4 mt-6 bg-blue-600 text-white hover:bg-blue-700"
              />
            </div>

            <div className="border-t border-gray-200 pt-4">
              <div className="grid grid-cols-12 gap-4 font-semibold text-gray-700 mb-2">
                <div className="col-span-1">#</div>
                <div className="col-span-8">Drop Downs</div>
                <div className="col-span-2">Status</div>
                <div className="col-span-1">Action</div>
              </div>
              {items.map((item, index) => (
                <div key={item.id} className="grid grid-cols-12 gap-4 items-center py-2 border-b border-gray-200">
                  <div className="col-span-1 text-gray-600">{index + 1}</div>
                  <div className="col-span-8 text-gray-700">{item.name}</div>
                  <div className="col-span-2">
                    <CustomSwitch
                      value={item.isActive}
                      name={`status-${section}-${item.id}`}
                      onChange={() => handleToggleStatus(section, item.id)}
                    />
                    <span className="ml-2 text-gray-600">{item.isActive ? "Enable" : "Disable"}</span>
                  </div>
                  <div className="col-span-1">
                    <button
                      onClick={() => handleDeleteDropdown(section, item.id)}
                      className="text-red-600 hover:text-red-800"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-5 h-5"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="p-4">
      {renderSection(
        "rejectionType",
        "Rejection Type",
        "Set Rejection Type for Advisor Profile rejection"
      )}
      {renderSection(
        "qualifications",
        "Qualifications",
        "Auto-assigned to the company's Relationship Manager."
      )}
    </div>
  );
};

export default DropdownsTab;